export * from './baFullCalendar.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baFullCalendar/index.ts